import $ from 'jquery';

const loadingMessage = {
    isVisible: false,
    show: function(includeOverlay) {
        if (!this.isVisible) {
            if (includeOverlay) {
                $('<div class="loader-msg-overlay"></div>').appendTo('body');
            }
            $(
                '<div id="loadingMessage" role="status" aria-live="polite" class="loader-msg-container">Loading<br /><img src="/images/indicator.gif" width="16px" height="16px" /></div>'
            ).appendTo('body');
            this.isVisible = true;
        }
    },
    hide: function() {
        if (this.isVisible) {
            $('.loader-msg-container, .loader-msg-overlay').remove();
            this.isVisible = false;
        }
    }
};

export default loadingMessage;
